import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import BetfairTopNav from "./top-nav-betfair";
import "../../../assets/css/betfair_games.css";
import useSocket from "../../../hooks/useSocket";
import BetfairCasinoBetslipWeb from "./betfair_casino_betslip_web";
import "../../../assets/css/betfair_games.css";
import "../../../assets/css/betfair_games_lo2.css";
import axiosInstance from "../../../utils/axiosInstance";
import TPPopUpBetSlip from "../tp-studio/teenpatti_casino_betslip_popup.jsx";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const BetfairHilo = () => {
  const [getBetDelayTime, setGetBetDelayTime] = useState([]);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const dispatch = useDispatch();
  const [stakeList, setStakeList] = useState({});

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [profileData, setProfileData] = useState(null);

  const [books, setBooks] = useState({});
  const [betList, setBetList] = useState([]);
  const [totalBets, setTotalBets] = useState(0);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState([]);
  const [showModal, setShowModal] = useState(false);

  let betfairOdds = null;
  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "bfgames",
    type: "hilo"
  });
  //console.log("Socket data:", data);

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  let evt_status = "";
  let roundId = "";
  let timeLeft = "";
  let time_percentage = "";
  let round = "";

  let higher = 0;
  let lower = 0;

  let runner1b1 = "";
  let runner1b2 = "";
  let runner1b3 = "";
  let runner1l1 = "";
  let runner1l2 = "";
  let runner1l3 = "";
  let runner2b1 = "";
  let runner2b2 = "";
  let runner2b3 = "";
  let runner2l1 = "";
  let runner2l2 = "";
  let runner2l3 = "";
  let runner3b1 = "";
  let runner3b2 = "";
  let runner3b3 = "";
  let runner3l1 = "";
  let runner3l2 = "";
  let runner3l3 = "";
  let runner4b1 = "";
  let runner4b2 = "";
  let runner4b3 = "";
  let runner4l1 = "";
  let runner4l2 = "";
  let runner4l3 = "";
  let runner5b1 = "";
  let runner5b2 = "";
  let runner5b3 = "";
  let runner5l1 = "";
  let runner5l2 = "";
  let runner5l3 = "";
  let runner6b1 = "";
  let runner6b2 = "";
  let runner6b3 = "";
  let runner6l1 = "";
  let runner6l2 = "";
  let runner6l3 = "";
  let runner7b1 = "";
  let runner7b2 = "";
  let runner7b3 = "";
  let runner7l1 = "";
  let runner7l2 = "";
  let runner7l3 = "";
  let runner8b1 = "";
  let runner8b2 = "";
  let runner8b3 = "";
  let runner8l1 = "";
  let runner8l2 = "";
  let runner8l3 = "";
  let runner9b1 = "";
  let runner9b2 = "";
  let runner9b3 = "";
  let runner9l1 = "";
  let runner9l2 = "";
  let runner9l3 = "";
  let runner10b1 = "";
  let runner10b2 = "";
  let runner10b3 = "";
  let runner10l1 = "";
  let runner10l2 = "";
  let runner10l3 = "";
  let runner11b1 = "";
  let runner11b2 = "";
  let runner11b3 = "";
  let runner11l1 = "";
  let runner11l2 = "";
  let runner11l3 = "";
  let runner12b1 = "";
  let runner12b2 = "";
  let runner12b3 = "";
  let runner12l1 = "";
  let runner12l2 = "";
  let runner12l3 = "";
  let runner13b1 = "";
  let runner13b2 = "";
  let runner13b3 = "";
  let runner13l1 = "";
  let runner13l2 = "";
  let runner13l3 = "";
  let runner14b1 = "";
  let runner14b2 = "";
  let runner14b3 = "";
  let runner14l1 = "";
  let runner14l2 = "";
  let runner14l3 = "";
  let runner15b1 = "";
  let runner15b2 = "";
  let runner15b3 = "";
  let runner15l1 = "";
  let runner15l2 = "";
  let runner15l3 = "";
  let runner16b1 = "";
  let runner16b2 = "";
  let runner16b3 = "";
  let runner16l1 = "";
  let runner16l2 = "";
  let runner16l3 = "";

  let runner1b1_matched = "";
  let runner1b2_matched = "";
  let runner1b3_matched = "";
  let runner1l1_matched = "";
  let runner1l2_matched = "";
  let runner1l3_matched = "";
  let runner2b1_matched = "";
  let runner2b2_matched = "";
  let runner2b3_matched = "";
  let runner2l1_matched = "";
  let runner2l2_matched = "";
  let runner2l3_matched = "";
  let runner3b1_matched = "";
  let runner3b2_matched = "";
  let runner3b3_matched = "";
  let runner3l1_matched = "";
  let runner3l2_matched = "";
  let runner3l3_matched = "";
  let runner4b1_matched = "";
  let runner4b2_matched = "";
  let runner4b3_matched = "";
  let runner4l1_matched = "";
  let runner4l2_matched = "";
  let runner4l3_matched = "";
  let runner5b1_matched = "";
  let runner5b2_matched = "";
  let runner5b3_matched = "";
  let runner5l1_matched = "";
  let runner5l2_matched = "";
  let runner5l3_matched = "";
  let runner6b1_matched = "";
  let runner6b2_matched = "";
  let runner6b3_matched = "";
  let runner6l1_matched = "";
  let runner6l2_matched = "";
  let runner6l3_matched = "";
  let runner7b1_matched = "";
  let runner7b2_matched = "";
  let runner7b3_matched = "";
  let runner7l1_matched = "";
  let runner7l2_matched = "";
  let runner7l3_matched = "";
  let runner8b1_matched = "";
  let runner8b2_matched = "";
  let runner8b3_matched = "";
  let runner8l1_matched = "";
  let runner8l2_matched = "";
  let runner8l3_matched = "";
  let runner9b1_matched = "";
  let runner9b2_matched = "";
  let runner9b3_matched = "";
  let runner9l1_matched = "";
  let runner9l2_matched = "";
  let runner9l3_matched = "";
  let runner10b1_matched = "";
  let runner10b2_matched = "";
  let runner10b3_matched = "";
  let runner10l1_matched = "";
  let runner10l2_matched = "";
  let runner10l3_matched = "";
  let runner11b1_matched = "";
  let runner11b2_matched = "";
  let runner11b3_matched = "";
  let runner11l1_matched = "";
  let runner11l2_matched = "";
  let runner11l3_matched = "";
  let runner12b1_matched = "";
  let runner12b2_matched = "";
  let runner12b3_matched = "";
  let runner12l1_matched = "";
  let runner12l2_matched = "";
  let runner12l3_matched = "";
  let runner13b1_matched = "";
  let runner13b2_matched = "";
  let runner13b3_matched = "";
  let runner13l1_matched = "";
  let runner13l2_matched = "";
  let runner13l3_matched = "";
  let runner14b1_matched = "";
  let runner14b2_matched = "";
  let runner14b3_matched = "";
  let runner14l1_matched = "";
  let runner14l2_matched = "";
  let runner14l3_matched = "";
  let runner15b1_matched = "";
  let runner15b2_matched = "";
  let runner15b3_matched = "";
  let runner15l1_matched = "";
  let runner15l2_matched = "";
  let runner15l3_matched = "";
  let runner16b1_matched = "";
  let runner16b2_matched = "";
  let runner16b3_matched = "";
  let runner16l1_matched = "";
  let runner16l2_matched = "";
  let runner16l3_matched = "";

  let rnr1_status = "";
  let rnr2_status = "";
  let rnr3_status = "";
  let rnr4_status = "";
  let rnr5_status = "";
  let rnr6_status = "";
  let rnr7_status = "";
  let rnr8_status = "";
  let rnr9_status = "";
  let rnr10_status = "";
  let rnr11_status = "";
  let rnr12_status = "";
  let rnr13_status = "";
  let rnr14_status = "";
  let rnr15_status = "";
  let rnr16_status = "";

  let suspend1 = "";
  let suspend2 = "";
  let suspend3 = "";
  let suspend4 = "";
  let suspend5 = "";
  let suspend6 = "";
  let suspend7 = "";
  let suspend8 = "";
  let suspend9 = "";
  let suspend10 = "";
  let suspend11 = "";
  let suspend12 = "";
  let suspend13 = "";
  let suspend14 = "";
  let suspend15 = "";
  let suspend16 = "";

  let cards_desc = "";
  let cardsDesc = [];
  let higlightedCard = "";

  let max = -219.99078369140625;
  let prediction = "";
  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };

  if (data != null && data.data !== null && data.data !== undefined) {
    betfairOdds = data.data;
    updateUserData(data?.user);

    roundId = betfairOdds.roundId;
    evt_status = betfairOdds.evt_status;
    timeLeft = betfairOdds.timeLeft;
    time_percentage = betfairOdds.time_percentage;
    round = betfairOdds.round;
    prediction = betfairOdds.prediction;

    runner1b1 = betfairOdds.runner1b1;
    runner1b2 = betfairOdds.runner1b2;
    runner1b3 = betfairOdds.runner1b3;

    runner1l1 = "";
    runner1l2 = "";
    runner1l3 = "";

    runner2b1 = betfairOdds.runner2b1;
    runner2b2 = betfairOdds.runner2b2;
    runner2b3 = betfairOdds.runner2b3;
    runner2l1 = "";
    runner2l2 = "";
    runner2l3 = "";

    runner3b1 = betfairOdds.runner3b1;
    runner3b2 = betfairOdds.runner3b2;
    runner3b3 = betfairOdds.runner3b3;

    runner3l1 = "";
    runner3l2 = "";
    runner3l3 = "";

    runner4b1 = betfairOdds.runner4b1;
    runner4b2 = betfairOdds.runner4b2;
    runner4b3 = betfairOdds.runner4b3;

    runner4l1 = "";
    runner4l2 = "";
    runner4l3 = "";

    runner5b1 = betfairOdds.runner5b1;
    runner5b2 = betfairOdds.runner5b2;
    runner5b3 = betfairOdds.runner5b3;

    runner5l1 = "";
    runner5l2 = "";
    runner5l3 = "";

    runner6b1 = betfairOdds.runner6b1;
    runner6b2 = betfairOdds.runner6b2;
    runner6b3 = betfairOdds.runner6b3;

    runner6l1 = "";
    runner6l2 = "";
    runner6l3 = "";

    runner7b1 = betfairOdds.runner7b1;
    runner7b2 = betfairOdds.runner7b2;
    runner7b3 = betfairOdds.runner7b3;

    runner7l1 = "";
    runner7l2 = "";
    runner7l3 = "";

    runner8b1 = betfairOdds.runner8b1;
    runner8b2 = betfairOdds.runner8b2;
    runner8b3 = betfairOdds.runner8b3;

    runner8l1 = "";
    runner8l2 = "";
    runner8l3 = "";

    runner9b1 = betfairOdds.runner9b1;
    runner9b2 = betfairOdds.runner9b2;
    runner9b3 = betfairOdds.runner9b3;

    runner9l1 = "";
    runner9l2 = "";
    runner9l3 = "";

    runner10b1 = betfairOdds.runner10b1;
    runner10b2 = betfairOdds.runner10b2;
    runner10b3 = betfairOdds.runner10b3;

    runner10l1 = "";
    runner10l2 = "";
    runner10l3 = "";

    runner11b1 = betfairOdds.runner11b1;
    runner11b2 = betfairOdds.runner11b2;
    runner11b3 = betfairOdds.runner11b3;

    runner11l1 = "";
    runner11l2 = "";
    runner11l3 = "";

    runner12b1 = betfairOdds.runner12b1;
    runner12b2 = betfairOdds.runner12b2;
    runner12b3 = betfairOdds.runner12b3;

    runner12l1 = "";
    runner12l2 = "";
    runner12l3 = "";

    runner13b1 = betfairOdds.runner13b1;
    runner13b2 = betfairOdds.runner13b2;
    runner13b3 = betfairOdds.runner13b3;

    runner13l1 = "";
    runner13l2 = "";
    runner13l3 = "";

    runner14b1 = betfairOdds.runner14b1;
    runner14b2 = betfairOdds.runner14b2;
    runner14b3 = betfairOdds.runner14b3;

    runner14l1 = "";
    runner14l2 = "";
    runner14l3 = "";

    runner15b1 = betfairOdds.runner15b1;
    runner15b2 = betfairOdds.runner15b2;
    runner15b3 = betfairOdds.runner15b3;

    runner15l1 = "";
    runner15l2 = "";
    runner15l3 = "";

    runner16b1 = betfairOdds.runner16b1;
    runner16b2 = betfairOdds.runner16b2;
    runner16b3 = betfairOdds.runner16b3;

    runner16l1 = "";
    runner16l2 = "";
    runner16l3 = "";

    runner1b1_matched = formatTruncate(betfairOdds?.runner1b1_matched);
    runner1b2_matched = formatTruncate(betfairOdds?.runner1b2_matched);
    runner1b3_matched = formatTruncate(betfairOdds?.runner1b3_matched);

    runner1l1_matched = "";
    runner1l2_matched = "";
    runner1l3_matched = "";

    runner2b1_matched = formatTruncate(betfairOdds?.runner2b1_matched);
    runner2b2_matched = formatTruncate(betfairOdds?.runner2b2_matched);
    runner2b3_matched = formatTruncate(betfairOdds?.runner2b3_matched);

    runner2l1_matched = "";
    runner2l2_matched = "";
    runner2l3_matched = "";

    runner3b1_matched = formatTruncate(betfairOdds?.runner3b1_matched);
    runner3b2_matched = formatTruncate(betfairOdds?.runner3b2_matched);
    runner3b3_matched = formatTruncate(betfairOdds?.runner3b3_matched);

    runner3l1_matched = "";
    runner3l2_matched = "";
    runner3l3_matched = "";

    runner4b1_matched = formatTruncate(betfairOdds?.runner4b1_matched);
    runner4b2_matched = formatTruncate(betfairOdds?.runner4b2_matched);
    runner4b3_matched = formatTruncate(betfairOdds?.runner4b3_matched);

    runner4l1_matched = "";
    runner4l2_matched = "";
    runner4l3_matched = "";

    runner5b1_matched = formatTruncate(betfairOdds?.runner5b1_matched);
    runner5b2_matched = formatTruncate(betfairOdds?.runner5b2_matched);
    runner5b3_matched = formatTruncate(betfairOdds?.runner5b3_matched);

    runner5l1_matched = "";
    runner5l2_matched = "";
    runner5l3_matched = "";

    runner6b1_matched = formatTruncate(betfairOdds?.runner6b1_matched);
    runner6b2_matched = formatTruncate(betfairOdds?.runner6b2_matched);
    runner6b3_matched = formatTruncate(betfairOdds?.runner6b3_matched);

    runner6l1_matched = "";
    runner6l2_matched = "";
    runner6l3_matched = "";

    runner7b1_matched = formatTruncate(betfairOdds?.runner7b1_matched);
    runner7b2_matched = formatTruncate(betfairOdds?.runner7b2_matched);
    runner7b3_matched = formatTruncate(betfairOdds?.runner7b3_matched);

    runner7l1_matched = "";
    runner7l2_matched = "";
    runner7l3_matched = "";

    runner8b1_matched = formatTruncate(betfairOdds?.runner8b1_matched);
    runner8b2_matched = formatTruncate(betfairOdds?.runner8b2_matched);
    runner8b3_matched = formatTruncate(betfairOdds?.runner8b3_matched);

    runner8l1_matched = "";
    runner8l2_matched = "";
    runner8l3_matched = "";

    runner9b1_matched = formatTruncate(betfairOdds?.runner9b1_matched);
    runner9b2_matched = formatTruncate(betfairOdds?.runner9b2_matched);
    runner9b3_matched = formatTruncate(betfairOdds?.runner9b3_matched);

    runner9l1_matched = "";
    runner9l2_matched = "";
    runner9l3_matched = "";

    runner10b1_matched = formatTruncate(betfairOdds?.runner10b1_matched);
    runner10b2_matched = formatTruncate(betfairOdds?.runner10b2_matched);
    runner10b3_matched = formatTruncate(betfairOdds?.runner10b3_matched);

    runner10l1_matched = "";
    runner10l2_matched = "";
    runner10l3_matched = "";

    runner11b1_matched = formatTruncate(betfairOdds?.runner11b1_matched);
    runner11b2_matched = formatTruncate(betfairOdds?.runner11b2_matched);
    runner11b3_matched = formatTruncate(betfairOdds?.runner11b3_matched);

    runner11l1_matched = "";
    runner11l2_matched = "";
    runner11l3_matched = "";

    runner12b1_matched = formatTruncate(betfairOdds?.runner12b1_matched);
    runner12b2_matched = formatTruncate(betfairOdds?.runner12b2_matched);
    runner12b3_matched = formatTruncate(betfairOdds?.runner12b3_matched);

    runner12l1_matched = "";
    runner12l2_matched = "";
    runner12l3_matched = "";

    runner13b1_matched = formatTruncate(betfairOdds?.runner13b1_matched);
    runner13b2_matched = formatTruncate(betfairOdds?.runner13b2_matched);
    runner13b3_matched = formatTruncate(betfairOdds?.runner13b3_matched);

    runner13l1_matched = "";
    runner13l2_matched = "";
    runner13l3_matched = "";

    runner14b1_matched = formatTruncate(betfairOdds?.runner14b1_matched);
    runner14b2_matched = formatTruncate(betfairOdds?.runner14b2_matched);
    runner14b3_matched = formatTruncate(betfairOdds?.runner14b3_matched);

    runner14l1_matched = "";
    runner14l2_matched = "";
    runner14l3_matched = "";

    runner15b1_matched = formatTruncate(betfairOdds?.runner15b1_matched);
    runner15b2_matched = formatTruncate(betfairOdds?.runner15b2_matched);
    runner15b3_matched = formatTruncate(betfairOdds?.runner15b3_matched);

    runner15l1_matched = "";
    runner15l2_matched = "";
    runner15l3_matched = "";

    runner16b1_matched = formatTruncate(betfairOdds?.runner16b1_matched);
    runner16b2_matched = formatTruncate(betfairOdds?.runner16b2_matched);
    runner16b3_matched = formatTruncate(betfairOdds?.runner16b3_matched);

    runner16l1_matched = "";
    runner16l2_matched = "";
    runner16l3_matched = "";

    rnr1_status = betfairOdds.rnr1_status;
    rnr2_status = betfairOdds.rnr2_status;
    rnr3_status = betfairOdds.rnr3_status;
    rnr4_status = betfairOdds.rnr4_status;
    rnr5_status = betfairOdds.rnr5_status;
    rnr6_status = betfairOdds.rnr6_status;
    rnr7_status = betfairOdds.rnr7_status;
    rnr8_status = betfairOdds.rnr8_status;
    rnr9_status = betfairOdds.rnr9_status;
    rnr10_status = betfairOdds.rnr10_status;
    rnr11_status = betfairOdds.rnr11_status;
    rnr12_status = betfairOdds.rnr12_status;
    rnr13_status = betfairOdds.rnr13_status;
    rnr14_status = betfairOdds.rnr14_status;
    rnr15_status = betfairOdds.rnr15_status;
    rnr16_status = betfairOdds.rnr16_status;

    suspend1 = betfairOdds.suspend1;
    suspend2 = betfairOdds.suspend2;
    suspend3 = betfairOdds.suspend3;
    suspend4 = betfairOdds.suspend4;
    suspend5 = betfairOdds.suspend5;
    suspend6 = betfairOdds.suspend6;
    suspend7 = betfairOdds.suspend7;
    suspend8 = betfairOdds.suspend8;
    suspend9 = betfairOdds.suspend9;
    suspend10 = betfairOdds.suspend10;
    suspend11 = betfairOdds.suspend11;
    suspend12 = betfairOdds.suspend12;
    suspend13 = betfairOdds.suspend13;
    suspend14 = betfairOdds.suspend14;
    suspend15 = betfairOdds.suspend15;
    suspend16 = betfairOdds.suspend16;

    if (evt_status == "SUSPENDED_GAME_ROUND_OVER") {
      if (rnr1_status != "IN_PLAY") {
        rnr1_status = rnr1_status;
      } else {
        rnr1_status = "ROUND OVER !";
      }

      if (rnr2_status != "IN_PLAY") {
        rnr2_status = rnr2_status;
      } else {
        rnr2_status = "ROUND OVER !";
      }

      if (rnr3_status != "IN_PLAY") {
        rnr3_status = rnr3_status;
      } else {
        rnr3_status = "ROUND OVER !";
      }

      if (rnr4_status != "IN_PLAY") {
        rnr4_status = rnr4_status;
      } else {
        rnr4_status = "ROUND OVER !";
      }

      if (rnr5_status != "IN_PLAY") {
        rnr5_status = rnr5_status;
      } else {
        rnr5_status = "ROUND OVER !";
      }

      if (rnr6_status != "IN_PLAY") {
        rnr6_status = rnr6_status;
      } else {
        rnr6_status = "ROUND OVER !";
      }

      if (rnr7_status != "IN_PLAY") {
        rnr7_status = rnr7_status;
      } else {
        rnr7_status = "ROUND OVER !";
      }

      if (rnr8_status != "IN_PLAY") {
        rnr8_status = rnr8_status;
      } else {
        rnr8_status = "ROUND OVER !";
      }

      if (rnr9_status != "IN_PLAY") {
        rnr9_status = rnr9_status;
      } else {
        rnr9_status = "ROUND OVER !";
      }

      if (rnr10_status != "IN_PLAY") {
        rnr10_status = rnr10_status;
      } else {
        rnr10_status = "ROUND OVER !";
      }

      if (rnr11_status != "IN_PLAY") {
        rnr11_status = rnr11_status;
      } else {
        rnr11_status = "ROUND OVER !";
      }

      if (rnr12_status != "IN_PLAY") {
        rnr12_status = rnr12_status;
      } else {
        rnr12_status = "ROUND OVER !";
      }

      if (rnr13_status != "IN_PLAY") {
        rnr13_status = rnr13_status;
      } else {
        rnr13_status = "ROUND OVER !";
      }

      if (rnr14_status != "IN_PLAY") {
        rnr14_status = rnr14_status;
      } else {
        rnr14_status = "ROUND OVER !";
      }

      if (rnr15_status != "IN_PLAY") {
        rnr15_status = rnr15_status;
      } else {
        rnr15_status = "ROUND OVER !";
      }

      if (rnr16_status != "IN_PLAY") {
        rnr16_status = rnr16_status;
      } else {
        rnr16_status = "ROUND OVER !";
      }
    }

    let nonSelArr = [40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
    cards_desc = betfairOdds?.cards_desc;

    if (cards_desc != "") {
      cardsDesc = cards_desc.split(",");
      if (cardsDesc.length > 0) {
        let z = 0;
        for (let x = 0; x < cardsDesc.length; x++) {
          z++;

          if (z == cardsDesc.length) {
            higlightedCard = cardsDesc[x];
          }

          let selCardVal = parseInt(cardsDesc[x]);
          if (selCardVal == 39) {
            selCardVal = 52;
          }

          //console.log("cards_desc->", cardsDesc);

          if (z == cardsDesc.length) {
            for (let y = 0; y < nonSelArr.length; y++) {
              if (selCardVal < nonSelArr[y]) {
                if (cardsDesc.indexOf(nonSelArr[y].toString()) === -1) {
                  higher++;
                }
              } else {
                if (cardsDesc.indexOf(nonSelArr[y].toString()) === -1) {
                  lower++;
                }
              }
            }
          }
        }
      }

      //console.log("higlightedCard->", higlightedCard);
    }
  }
  const getCardImage = (cardValue) => {
    if (cardValue === "NOT AVAILABLE") {
      return `/assets/images/bpstudio/cards/card_simple_omaha_back_bf.svg`;
    }

    if (["28", "33", "39", "40"].includes(cardValue)) {
      return `/assets/images/bpstudio/cards/card_simple_${cardValue}.png`;
    }

    return `/assets/images/bpstudio/cards/card_simple_${cardValue}.svg`;
  };

  /// place bet ///

  const showBetfairBetSlip = (bettype, teamname, selectRnr, price) => {
    if (price <= 0) {
      return;
    }
    let placeBetObject = {
      amount: 0,
      catmid: "",
      market_type: "m",
      game_name: "betfair_hilo"
    };
    placeBetObject.catmid = roundId;
    placeBetObject.round = round;
    //console.log(placeBetObject);
    placeBetObject.odds = price;
    placeBetObject.teamname = teamname;
    placeBetObject.bettype = bettype;
    placeBetObject.selectRnr = selectRnr;
    placeBetObject.marketVal = 1;
    placeBetObject.game_type = 9;

    setPlaceBetObject(placeBetObject);
    console.log("isMobile: ", isMobile);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
    //showBetfairSlipStatus = true;
  };
  /// place bet ///

  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  const closeBetSlip = () => {
    setShowBetSlip(false);
  };

  const fetchProfile = async () => {
    try {
      const { data } = await axiosInstance.get("/profile");
      setProfileData(data);

      setStakeList({
        stake1: data.response.stake1,
        stake2: data.response.stake2,
        stake3: data.response.stake3,
        stake4: data.response.stake4,
        stake5: data.response.stake5,
        stake6: data.response.stake6,
        stake7: data.response.stake7,
        stake8: data.response.stake8
      });
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  const getDelayTimes = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/event-limits");
      setGetBetDelayTime(data);
    } catch (error) {
      console.error("Failed to load getDelayTimes data:", error);
    }
  };

  const delayTime = (game_type) => {
    let defaultTime = 8;
    if (getBetDelayTime) {
      for (let i = 0; i < getBetDelayTime.response?.length; i++) {
        let obj = getBetDelayTime.response[i];
        if (obj.game_type == game_type) {
          defaultTime = obj.value;
          break;
        }
      }
    }

    return defaultTime;
  };

  const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

  useEffect(() => {
    fetchProfile();
    getDelayTimes();
  }, []);

  const isProcessing = useRef(false);
  const [loading, setLoading] = useState(false);

  const placeBet = async (amount, profit) => {
    if (isProcessing.current) return;

    isProcessing.current = true;
    setLoading(true);

    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    console.log(placeBetObject);
    let delay = delayTime(7);
    console.log("delay->", delay);
    try {
      await sleep(delay * 1000);
      const response = await axiosInstance.post(
        "/betfair-hilo",
        placeBetObject
      );
      //console.log(response);
      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
        setShowBetSlipPopup(false);
        //toast.success(response.data.message);
        //getBook(placeBetObject.catmid);
        fetchUserData(); //balance update on top
        getBook();
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
          //toast.error(errorMessage);
        }
      }
    } finally {
      isProcessing.current = false;
      setLoading(false);
    }
  };

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const getBook = async () => {
    let bookObject = {};
    bookObject.roundId = roundId;
    bookObject.game_type = "betfair-hilo";

    const response = await axiosInstance.post("/betfair-book", bookObject);
    console.log("response->", response.data);
    ///
    let userbook = response.data.userbook;
    let bet_list = response.data.bets_list;
    const bookObj = {};
    if (userbook.length > 0) {
      let z = 0;
      const maxBooks = 16; // maximum number of dynamic variables you want
      for (let i = 1; i <= maxBooks; i++) {
        bookObj[`bookB${i}`] = "";
        bookObj[`bookL${i}`] = "";
      }
      setBooks(bookObj);
      for (let x = 0; x < userbook.length; x++) {
        z++;
        let splitSid = userbook[x].rnr_sid.split("-");
        let bookVal = splitSid[1];
        bookObj[`bookB${bookVal}`] = userbook[x].bak;
        bookObj[`bookL${bookVal}`] = userbook[x].lay;
      }
      setBooks(bookObj);
    } else {
      const maxBooks = 16; // maximum number of dynamic variables you want
      for (let i = 1; i <= maxBooks; i++) {
        bookObj[`bookB${i}`] = "";
        bookObj[`bookL${i}`] = "";
      }
      setBooks(bookObj);
    }

    if (bet_list.length > 0) {
      setTotalBets(bet_list.length);
      setBetList(bet_list);
    } else {
      setBetList([]);
    }

    ///
    return response;
  };

  useEffect(
    (roundId) => {
      getBook();
    },
    [roundId]
  );

  const isFoundNumber = (number, higlightedCard) => {
    cards_desc = betfairOdds?.cards_desc;
    let isFound = false;
    if (higlightedCard == number) {
      isFound = false;
    } else {
      if (cards_desc != "" && cards_desc != undefined) {
        cardsDesc = cards_desc.split(",");

        if (cardsDesc.length > 0) {
          if (cardsDesc.indexOf(number.toString()) >= 0) {
            isFound = true;
          }
        }
      }
    }

    return isFound;
  };
  const getHiglightCss = (higlightedCard, number) => {
    let returnCss = "value-element";
    if (higlightedCard !== "" && higlightedCard == number) {
      returnCss = "value-element highlighted";
    }
    return returnCss;
  };

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "betfair-hilo";

    const response = await axiosInstance.post("/betfair-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
    setShowResult(true);
  };

  const hideResultDetail = async () => {
    setShowResult(false);
  };

  ///
  const isMobile = window.innerWidth <= 576;
  const tableStyle = { width: "100%", borderCollapse: "collapse" };
  const rowFlexStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "transparent"
  };
  const MobrowFlexStyle = {
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    background: "transparent"
  };
  const tdResultsStyle = {
    padding: 1,
    minWidth: 180,
    boxSizing: "border-box",
    minHeight: "115px",
    height: "auto"
  };
  const MobtdResultsStyle = {
    padding: "0px 0px 0px 0px",
    boxSizing: "border-box"
  };
  const playerCardsStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowWrap: "break-word"
  };
  const playerNameStyle = {
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const cardImagesStyle = {
    display: "flex",
    justifyContent: "center",
    gap: 3,
    flexWrap: "wrap",
    width: "100%"
  };
  const cardImgStyle = {
    width: 40,
    height: 60,
    objectFit: "cover",
    borderRadius: 5
  };
  const playerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%"
  };
  const MobplayerStatusStyle = {
    color: "#000",
    marginTop: 5,
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    boxSizing: "border-box"
  };
  ///
  const closeButton = () => {
    setShowModal(false);
  };

  const [isPageLoad, setIsPageLoad] = useState(false);
  useEffect(() => {
    if (data !== null && data !== undefined) {
      setIsPageLoad(true);
    }
  }, [data]);

  const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(
      2,
      "0"
    )}:${minutes} ${ampm}`;
  };

  return (
    <ClientLayout showLoader={false}>
      <style>
        {`
         
          .ExMainCardbundle .runner-position {
            bottom: 0px;
         }
          .ExMainCardbundle .runner-name {
              padding-top: 1px;
          }
          .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .player-card.stood, .andarbahar-player-card {
          margin-left:auto;
          margin-right:auto;
          min-height:auto;
        }
          .modal-content-style {
          max-width: 1000px !important;
          width: 100% !important;
          max-height: 95vh !important;
        }

        @media (max-width:768px)
        {
          .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            min-width: 145px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
          }
          
        }
          .no-border {
            border-bottom: none !important;
          }
          #ExgamesDiv > .col-lg-8.Exgamesbg {
            padding-left: 5px !important;
            padding-right: 5px !important;
          }
        `}
      </style>
      <div
        style={{
          paddingLeft: "10px",
          paddingRight: "10px",
          background: "#ffffff"
        }}
      >
        <div className="ExMainCardbundle" style={{ marginBottom: "8px" }}>
          <div className="card-header">
            <BetfairTopNav></BetfairTopNav>
          </div>

          {!isPageLoad && (
            <div
              style={{
                zIndex: "1000",
                background: "#fff",
                width: "100%",
                height: "20%",
                opacity: 1,
                textAlign: "center"
              }}
            >
              <div>
                <img src="../assets/images/loadinggif.gif" alt="Loader" />
              </div>
            </div>
          )}

          <div
            className="card-body mainexcard"
            style={{ display: isPageLoad ? "block" : "none" }}
          >
            <div id="ExgamesDiv" className="row">
              <div className="col-lg-8 Exgamesbg">
                <div>
                  <div
                    className="container text-center"
                    style={{
                      background: "#292929",
                      width: isMobile ? "95%" : "100%",
                      padding: "3px"
                    }}
                  >
                    <center className="row">
                      <div className="col-md-4 ExRounds">
                        <div className="round-counter-simple">
                          <div className="round-counter-text">
                            <span className="i18n">Round</span>
                          </div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 1 ? "active" : ""
                            }`}
                            id="roundCounter1"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 2 ? "active" : ""
                            }`}
                            id="roundCounter2"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 3 ? "active" : ""
                            }`}
                            id="roundCounter3"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 4 ? "active" : ""
                            }`}
                            id="roundCounter4"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 5 ? "active" : ""
                            }`}
                            id="roundCounter5"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 6 ? "active" : ""
                            }`}
                            id="roundCounter6"
                          ></div>
                          <div
                            className={`round-counter-item-simple roundCounter ${
                              round == 7 ? "active" : ""
                            }`}
                            id="roundCounter7"
                          ></div>
                        </div>
                      </div>
                      <div className="col-4 col-md-4">
                        <div id="demoTimer" className="col">
                          <div className="base-timer casino-timer">
                            <svg
                              className="progressBar"
                              x="0px"
                              y="0px"
                              viewBox="0 0 80 80"
                            >
                              <path
                                className="track"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                              />
                              <path
                                className="fill fill_green"
                                d="M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0"
                                style={{
                                  strokeDashoffset: ((30 - timeLeft) / 30) * max
                                }}
                              />
                              <text
                                className="value"
                                x="50%"
                                y="55%"
                                style={{
                                  fontSize: "30px",
                                  fontWeight: "bold"
                                }}
                              >
                                {timeLeft}
                              </text>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="col-8  col-md-4 inline-block Gameidcol">
                        Game ID:<span id="round-id">{roundId}</span>
                        <div
                          role="group"
                          aria-label="Second group"
                          className="btn-group btn-group-sm mr-2"
                        >
                          <button
                            type="button"
                            id="Alltab"
                            className={`tablink 
                                                btn 
                                                btn-primary 
                                                 ${
                                                   showResult ? "" : "bbactive"
                                                 }`}
                            onClick={() => hideResultDetail()}
                          >
                            Game
                          </button>
                          <button
                            type="button"
                            id="RESULTStab"
                            className={`tablink 
                                                btn 
                                                btn-primary 
                                                 ${
                                                   showResult ? "bbactive" : ""
                                                 }`}
                            onClick={() => showResultDetail()}
                          >
                            Results
                          </button>
                          <button
                            type="button"
                            className="tablink btn btn-primary "
                            data-toggle="modal"
                            data-target="#rulesPopup"
                            style={{ display: "inline-block" }}
                            onClick={() => setShowModal(true)}
                          >
                            Rules
                          </button>
                          {showModal && (
                            <div
                              class="modal fade show"
                              id="rulesPopup"
                              tabindex="-1"
                              role="dialog"
                              data-keyboard="false"
                              data-backdrop="static"
                              style={{ display: "block", paddingLeft: "0px" }}
                            >
                              <div
                                class="modal-dialog modal-lg"
                                role="document"
                              >
                                <div
                                  class="modal-content modal-content-style"
                                  style={{
                                    backgroundColor: "#3C444B",
                                    color: "#AAAFB5",
                                    borderRadius: "6px"
                                  }}
                                >
                                  <div
                                    class="modal-header"
                                    style={{
                                      borderBottom: "0px",
                                      padding: "5px",
                                      background: "#e0e0e0"
                                    }}
                                  >
                                    <div
                                      class="modal-title"
                                      id="exampleModalLabel"
                                      style={{
                                        fontSize: "20px",
                                        color: "rgba(0,0,0,.87)",
                                        margin: "5px 0px 0px 10px"
                                      }}
                                    >
                                      <b>Market Rules</b>
                                    </div>
                                    <button
                                      type="button"
                                      class="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      style={{
                                        color: "white",
                                        margin: "-0.5rem -0.7rem -1rem auto"
                                      }}
                                    >
                                      <span
                                        aria-hidden="true"
                                        style={{
                                          color: "#000",
                                          opacity: "0.8"
                                        }}
                                        onClick={closeButton}
                                      >
                                        ×
                                      </span>
                                    </button>
                                  </div>
                                  <div
                                    class="modal-body"
                                    style={{
                                      marginTop: "0px",
                                      background: "#fff"
                                    }}
                                  >
                                    <div
                                      style={{
                                        background: "#fff",
                                        padding: "10px",
                                        borderRadius: "10px"
                                      }}
                                    >
                                      <div class="row">
                                        <div
                                          class="col-lg-12"
                                          style={{ color: "rgba(0,0,0,.87)" }}
                                        >
                                          <div
                                            id="market-rules-text"
                                            class="modal-body"
                                          >
                                            <div class="rules-component">
                                              <div
                                                class="text-block-renderer-component"
                                                style={{ textAlign: "left" }}
                                              >
                                                <div class="section">
                                                  <h2 class="section-title">
                                                    <span class="i18n">
                                                      Variable Handicap Betting
                                                    </span>
                                                  </h2>
                                                  <div class="section-content">
                                                    {/*<p class="paragraph"><span class="i18n bold">Total matched so far: </span>$0</p>*/}
                                                    <p class="paragraph">
                                                      <span class="i18n bold">
                                                        Commission on this
                                                        market:{" "}
                                                      </span>
                                                      1%
                                                    </p>
                                                    <p class="paragraph">
                                                      <span class="i18n text">
                                                        This is an introductory
                                                        commission rate.
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                                <div class="section-content">
                                                  <h3 class="section-highlight">
                                                    <span class="i18n">
                                                      What is Exchange Hi Lo?
                                                    </span>
                                                  </h3>
                                                  <p class="paragraph">
                                                    <span class="i18n text">
                                                      Exchange <b> Hi Lo </b> is
                                                      Betfair's version of the
                                                      popular and exciting card
                                                      game in which a player has
                                                      to predict whether the
                                                      next card is{" "}
                                                      <b> Higher or Lower </b>.
                                                      However, in Betfair's
                                                      unique variation, it's the
                                                      computer that decides
                                                      whether the next card will
                                                      be higher or lower, and
                                                      you bet on how many cards
                                                      it predicts correctly
                                                      before it gets it wrong.
                                                      The game uses one suit of{" "}
                                                      <b>
                                                        {" "}
                                                        spades and the Ace{" "}
                                                      </b>{" "}
                                                      is high. The{" "}
                                                      <b>
                                                        {" "}
                                                        computer's strategy is
                                                        simple{" "}
                                                      </b>
                                                      ; if there are an equal
                                                      number or more cards above
                                                      the last dealt card, then
                                                      it will go higher, if
                                                      there are more cards
                                                      below, it will go lower.
                                                      For example, if the first
                                                      card dealt is 5, there are
                                                      3 cards that are lower and
                                                      9 that are higher, so the
                                                      computer will predict that
                                                      the next card will be
                                                      higher. To help you out
                                                      we've included a card
                                                      counter that tells you how
                                                      many cards are higher or
                                                      lower and which cards have
                                                      already been displayed..
                                                    </span>
                                                  </p>
                                                </div>
                                                <div class="section">
                                                  <h2 class="section-title">
                                                    <span class="i18n">
                                                      BetProExch Exchange Hi Lo
                                                    </span>
                                                  </h2>
                                                  <div class="section-content">
                                                    <h3 class="section-highlight">
                                                      <span class="i18n">
                                                        Rules
                                                      </span>
                                                    </h3>
                                                    <p class="paragraph"></p>
                                                    <ul>
                                                      <li>
                                                        <span class="i18n">
                                                          Each game uses 13
                                                          cards, one of each
                                                          value from a suit of
                                                          spades.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          Ace is always high.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          If there are an equal
                                                          number or more cards
                                                          above the last dealt
                                                          card, then the
                                                          computer will go
                                                          higher.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          If there are more
                                                          cards below the last
                                                          dealt card the
                                                          computer will go
                                                          lower.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          Players can place back
                                                          or lay bets on how far
                                                          they think the
                                                          computer will
                                                          correctly predict the
                                                          cards before it
                                                          predicts incorrectly.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          The game ends if the
                                                          next prediction is
                                                          incorrect, otherwise
                                                          the game continues
                                                          until the last card.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          Guaranteed outcome
                                                          selections are settled
                                                          prior to the next
                                                          round of betting.
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          Card 11 and the Last
                                                          card will be turned
                                                          over at the same time
                                                          if Card 11 is
                                                          predicted correctly.
                                                        </span>
                                                      </li>
                                                    </ul>
                                                    <p></p>
                                                  </div>
                                                  <div class="section-content">
                                                    <h3 class="section-highlight">
                                                      <span class="i18n">
                                                        Side bets market
                                                      </span>
                                                    </h3>
                                                    <p class="paragraph">
                                                      <span class="i18n text">
                                                        The 'Side bets market'
                                                        has the following
                                                        selections:
                                                      </span>
                                                    </p>
                                                    <p class="paragraph"></p>
                                                    <ol>
                                                      <li>
                                                        <span class="i18n">
                                                          2 card run - 2 cards
                                                          in a row in ascending
                                                          or descending value
                                                          order, e.g. 2, 3 or
                                                          King, Queen
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          3 card run - 3 cards
                                                          in a row in ascending
                                                          or descending value
                                                          order, e.g. 2, 3, 4 or
                                                          Queen, Jack, 10
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          4 card run - 4 cards
                                                          in a row in ascending
                                                          or descending value
                                                          order, e.g. 3, 4, 5, 6
                                                          or Ace, King, Queen,
                                                          Jack
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          No Ace - the game ends
                                                          with no Ace dealt
                                                        </span>
                                                      </li>
                                                      <li>
                                                        <span class="i18n">
                                                          No picture cards - the
                                                          game ends with no
                                                          picture cards dealt.
                                                          Picture cards are
                                                          Jack, Queen, King and
                                                          Ace
                                                        </span>
                                                      </li>
                                                    </ol>
                                                    <p></p>
                                                    <p class="paragraph">
                                                      <span class="i18n text">
                                                        For the 'Side bets
                                                        market', the outcome is
                                                        settled on the cards
                                                        shown, regardless of
                                                        whether the card was
                                                        predicted correctly or
                                                        not. For example, if the
                                                        Start card was a King
                                                        then the computer would
                                                        predict lower, and if
                                                        Card 1 was an Ace, then
                                                        the game would end.
                                                        However, the 'No Ace'
                                                        selection of the 'Side
                                                        bets market' would be
                                                        settled as a loser,
                                                        because an Ace was dealt
                                                        during the game.
                                                      </span>
                                                    </p>
                                                    <p class="paragraph">
                                                      <span class="i18n text">
                                                        For further information
                                                        and examples, please go
                                                        to our{" "}
                                                        <a
                                                          href="https://support.betfair.com/app/answers/list/c/484/"
                                                          target="_blank"
                                                          class="rules-link"
                                                        >
                                                          Exchange Hi Lo Help
                                                        </a>{" "}
                                                        section.
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </center>
                  </div>
                </div>
                <div
                  id="AlltabData"
                  className="tabcontent"
                  style={{ display: showResult ? "none" : "contents" }}
                >
                  <div className="left-content">
                    <div className="cards-layout blackjack">
                      <div>
                        <div className="dealer">
                          <div className="player-item">
                            <span className="name">Board</span>
                            <div className="player-card">
                              <div className="cards-layout">
                                <ul
                                  className="first-row"
                                  style={{ marginLeft: "5px" }}
                                  id="cards_desc"
                                >
                                  <li
                                    className="card-item"
                                    style={{
                                      display: !cards_desc
                                        ? "inline-block"
                                        : "none"
                                    }}
                                  >
                                    <div className="card">
                                      <img
                                        src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/card_simple_omaha_back.svg"
                                        alt="card"
                                        className="hiloimg"
                                      />
                                    </div>
                                  </li>
                                  <li
                                    className="card-item"
                                    style={{
                                      display: !cards_desc
                                        ? "inline-block"
                                        : "none"
                                    }}
                                  >
                                    <div className="card">
                                      <img
                                        src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/card_simple_omaha_back.svg"
                                        alt="card"
                                        className="hiloimg"
                                      />
                                    </div>
                                  </li>
                                  <li
                                    className="card-item"
                                    style={{
                                      display: !cards_desc
                                        ? "inline-block"
                                        : "none"
                                    }}
                                  >
                                    <div className="card">
                                      <img
                                        src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/card_simple_omaha_back.svg"
                                        alt="card"
                                        className="hiloimg"
                                      />
                                    </div>
                                  </li>

                                  {cardsDesc &&
                                    cardsDesc.length > 0 &&
                                    cardsDesc.map((card, index) => {
                                      if (cards_desc) {
                                        const cardImage = getCardImage(card);
                                        const cardClass = `card${index + 1}in2`;
                                        let textVal = "";
                                        if (index == 0) {
                                          textVal = "Start";
                                        } else {
                                          textVal = index;
                                        }
                                        return (
                                          <li className="card-item">
                                            <div class="card">
                                              <img
                                                src={cardImage}
                                                alt="card"
                                                className="hiloimg"
                                              />
                                            </div>
                                            <span class="card-name">
                                              {textVal}
                                            </span>
                                          </li>
                                        );
                                      }
                                    })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="prediction">
                        <div className="prediction-text">
                          <span className="prediction-description">
                            <span className="i18n">
                              Computer predicts next card:{" "}
                            </span>
                          </span>
                          <span className="prediction-value" id="predictionVal">
                            {prediction == "Lower" ? (
                              <span>
                                Lo
                                <img
                                  id="predictionCls"
                                  src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/arrow-down.svg?v=552"
                                  alt="prediction-arrow"
                                  className="lower"
                                />
                              </span>
                            ) : (
                              <span>
                                Hi
                                <img
                                  id="predictionCls"
                                  src="https://ie1-gfebf.cdnppb.net/gfe-website-betfair-xgames-xgames/client/assets/images/arrow-down.svg?v=552"
                                  alt="prediction-arrow"
                                  style={{ transform: "rotate(180deg)" }}
                                />
                              </span>
                            )}
                          </span>
                          (
                          <span className="i18n">
                            Game ends if the next card is{" "}
                          </span>
                          <span className="i18n">Higher</span>)
                        </div>
                        <div className="prediction-table">
                          <div className="number-of-cards-element lower highlighted">
                            <span id="lowerVal">{lower}</span>{" "}
                            <span className="i18n">Lower</span>
                          </div>
                          <div className="values">
                            {" "}
                            <div className={getHiglightCss(higlightedCard, 40)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(40, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                2
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 41)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(41, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                3
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 42)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(42, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                4
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 43)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(43, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                5
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 44)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(44, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                6
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 45)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(45, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                7
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 46)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(46, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                8
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 47)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(47, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                9
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 48)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(48, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                10
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 49)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(49, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                J
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 50)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(50, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                Q
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 51)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(51, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                K
                              </span>
                            </div>
                            <div className={getHiglightCss(higlightedCard, 39)}>
                              <span
                                style={{
                                  display: "inline-block",
                                  opacity: isFoundNumber(39, higlightedCard)
                                    ? 0.3
                                    : 1
                                }}
                              >
                                A
                              </span>
                            </div>
                          </div>

                          <div className="number-of-cards-element higher">
                            <span id="higherVal">{higher}</span>{" "}
                            <span className="i18n">Higher</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <center>
                      <div
                        className="progress"
                        style={{
                          height: "3px",
                          maxWidth: "50%",
                          marginBottom: "8px"
                        }}
                      >
                        <div
                          id="Exgamesprogress"
                          role="progressbar"
                          aria-valuenow="0"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          className="progress-bar bg-danger"
                          style={{ width: `${time_percentage}%` }}
                          sid="roundProgressWidth"
                        ></div>
                      </div>
                    </center>
                    <div className="section-blur">
                      <div className="market-titlebar">
                        <p className="market-name"></p>
                        <div className="market-overarround">
                          <span></span>
                          <strong>Back</strong>
                        </div>
                        <div className="market-overarround market-overarround-lay">
                          <strong>Lay</strong>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b1status">
                          <h3
                            className={`runner-name ${
                              rnr1_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 1 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus1">
                                    {books.bookB1 !== "" ? (
                                      <span>
                                        {Number(books.bookB1) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB1)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB1)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL1)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b3span"
                            data-teamname="Card 1 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 1 or further",
                                "3",
                                runner1b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner1b3">
                              {runner1b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b3_matched"
                            >
                              {runner1b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr1_status span1details"
                            id="runner1b2span"
                            data-teamname="Card 1 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 1 or further",
                                "2",
                                runner1b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner1b2">
                              {runner1b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b2_matched"
                            >
                              {runner1b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr1_status span1details"
                            id="runner1b1span"
                            data-teamname="Card 1 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 1 or further",
                                "1",
                                runner1b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner1b1">
                              {runner1b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner1b1_matched"
                            >
                              {runner1b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr1_status span1details"
                            id="runner1l1span"
                            data-teamname="Card 1 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 1 or further",
                                "1",
                                runner1l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner1l1"></span>
                            <span
                              className="price-amount"
                              id="runner1l1_matched"
                            ></span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l2span"
                            data-teamname="Card 1 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 1 or further",
                                "2",
                                runner1l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner1l2"></span>
                            <span
                              className="price-amount"
                              id="runner1l2_matched"
                            ></span>
                          </a>
                          <a
                            className="price-price price-lay rnr1_status span1details"
                            id="runner1l3span"
                            data-teamname="Card 1 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 1 or further",
                                "3",
                                runner1l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner1l3"></span>
                            <span
                              className="price-amount"
                              id="runner1l3_matched"
                            ></span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr1_status"
                            style={{
                              display:
                                suspend1 != 0 ||
                                rnr1_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr1_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b2status">
                          <h3
                            className={`runner-name ${
                              rnr2_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 2 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus2">
                                    {books.bookB2 !== "" ? (
                                      <span>
                                        {Number(books.bookB2) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB2)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB2)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL2)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b3span"
                            data-teamname="Card 2 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 2 or further",
                                "3",
                                runner2b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner2b3">
                              {runner2b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b3_matched"
                            >
                              {runner2b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr2_status span1details"
                            id="runner2b2span"
                            data-teamname="Card 2 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 2 or further",
                                "2",
                                runner2b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner2b2">
                              {runner2b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b2_matched"
                            >
                              {runner2b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr2_status span1details"
                            id="runner2b1span"
                            data-teamname="Card 2 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 2 or further",
                                "1",
                                runner2b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner2b1">
                              {runner2b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2b1_matched"
                            >
                              {runner2b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr2_status span1details"
                            id="runner2l1span"
                            data-teamname="Card 2 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 2 or further",
                                "1",
                                runner2l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner2l1">
                              {runner2l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l1_matched"
                            >
                              {runner2l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l2span"
                            data-teamname="Card 2 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 2 or further",
                                "2",
                                runner2l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner2l2">
                              {runner2l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l2_matched"
                            >
                              {runner2l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr2_status span1details"
                            id="runner2l3span"
                            data-teamname="Card 2 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 2 or further",
                                "3",
                                runner2l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner2l3">
                              {runner2l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner2l3_matched"
                            >
                              {runner2l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr2_status"
                            style={{
                              display:
                                suspend2 != 0 ||
                                rnr2_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr2_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b3status">
                          <h3
                            className={`runner-name ${
                              rnr3_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 3 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus3">
                                    {books.bookB3 !== "" ? (
                                      <span>
                                        {Number(books.bookB3) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB3)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB3)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL3)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b3span"
                            data-teamname="Card 3 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 3 or further",
                                "3",
                                runner3b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner3b3">
                              {runner3b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b3_matched"
                            >
                              {runner3b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr3_status span1details"
                            id="runner3b2span"
                            data-teamname="Card 3 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 3 or further",
                                "2",
                                runner3b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner3b2">
                              {runner3b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b2_matched"
                            >
                              {runner3b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr3_status span1details"
                            id="runner3b1span"
                            data-teamname="Card 3 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 3 or further",
                                "1",
                                runner3b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner3b1">
                              {runner3b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3b1_matched"
                            >
                              {runner3b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr3_status span1details"
                            id="runner3l1span"
                            data-teamname="Card 3 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 3 or further",
                                "1",
                                runner3l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner3l1">
                              {runner3l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l1_matched"
                            >
                              {runner3l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l2span"
                            data-teamname="Card 3 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 3 or further",
                                "2",
                                runner3l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner3l2">
                              {runner3l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l2_matched"
                            >
                              {runner3l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr3_status span1details"
                            id="runner3l3span"
                            data-teamname="Card 3 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 3 or further",
                                "3",
                                runner3l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner3l3">
                              {runner3l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner3l3_matched"
                            >
                              {runner3l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr3_status"
                            style={{
                              display:
                                suspend3 != 0 ||
                                rnr3_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr3_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b4status">
                          <h3
                            className={`runner-name ${
                              rnr4_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 4 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus4">
                                    {books.bookB4 !== "" ? (
                                      <span>
                                        {Number(books.bookB4) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB4)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB4)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL4)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b3span"
                            data-teamname="Card 4 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 4 or further",
                                "3",
                                runner4b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner4b3">
                              {runner4b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b3_matched"
                            >
                              {runner4b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr4_status span1details"
                            id="runner4b2span"
                            data-teamname="Card 4 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 4 or further",
                                "2",
                                runner4b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner4b2">
                              {runner4b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b2_matched"
                            >
                              {runner4b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr4_status span1details"
                            id="runner4b1span"
                            data-teamname="Card 4 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 4 or further",
                                "1",
                                runner4b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner4b1">
                              {runner4b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4b1_matched"
                            >
                              {runner4b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr4_status span1details"
                            id="runner4l1span"
                            data-teamname="Card 4 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 4 or further",
                                "1",
                                runner4l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner4l1">
                              {runner4l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l1_matched"
                            >
                              {runner4l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l2span"
                            data-teamname="Card 4 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 4 or further",
                                "2",
                                runner4l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner4l2">
                              {runner4l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l2_matched"
                            >
                              {runner4l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr4_status span1details"
                            id="runner4l3span"
                            data-teamname="Card 4 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 4 or further",
                                "3",
                                runner4l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner4l3">
                              {runner4l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner4l3_matched"
                            >
                              {runner4l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr4_status"
                            style={{
                              display:
                                suspend4 != 0 ||
                                rnr4_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr4_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b5status">
                          <h3
                            className={`runner-name ${
                              rnr5_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 5 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus5">
                                    {books.bookB5 !== "" ? (
                                      <span>
                                        {Number(books.bookB5) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB5)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB5)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL5)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr5_status span1details"
                            id="runner5b3span"
                            data-teamname="Card 5 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 5 or further",
                                "3",
                                runner5b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner5b3">
                              {runner5b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5b3_matched"
                            >
                              {runner5b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr5_status span1details"
                            id="runner5b2span"
                            data-teamname="Card 5 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 5 or further",
                                "2",
                                runner5b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner5b2">
                              {runner5b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5b2_matched"
                            >
                              {runner5b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr5_status span1details"
                            id="runner5b1span"
                            data-teamname="Card 5 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 5 or further",
                                "1",
                                runner5b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner5b1">
                              {runner5b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5b1_matched"
                            >
                              {runner5b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr5_status span1details"
                            id="runner5l1span"
                            data-teamname="Card 5 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 5 or further",
                                "1",
                                runner5l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner5l1">
                              {runner5l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5l1_matched"
                            >
                              {runner5l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr5_status span1details"
                            id="runner5l2span"
                            data-teamname="Card 5 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 5 or further",
                                "2",
                                runner5l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner5l2">
                              {runner5l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5l2_matched"
                            >
                              {runner5l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr5_status span1details"
                            id="runner5l3span"
                            data-teamname="Card 5 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 5 or further",
                                "3",
                                runner5l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner5l3">
                              {runner5l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner5l3_matched"
                            >
                              {runner5l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr5_status"
                            style={{
                              display:
                                suspend5 != 0 ||
                                rnr5_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr5_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b6status">
                          <h3
                            className={`runner-name ${
                              rnr6_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 6 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus6">
                                    {books.bookB6 !== "" ? (
                                      <span>
                                        {Number(books.bookB6) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB6)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB6)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL6)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr6_status span1details"
                            id="runner6b3span"
                            data-teamname="Card 6 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 6 or further",
                                "3",
                                runner6b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner6b3">
                              {runner6b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6b3_matched"
                            >
                              {runner6b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr6_status span1details"
                            id="runner6b2span"
                            data-teamname="Card 6 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 6 or further",
                                "2",
                                runner6b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner6b2">
                              {runner6b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6b2_matched"
                            >
                              {runner6b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr6_status span1details"
                            id="runner6b1span"
                            data-teamname="Card 6 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 6 or further",
                                "1",
                                runner6b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner6b1">
                              {runner6b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6b1_matched"
                            >
                              {runner6b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr6_status span1details"
                            id="runner6l1span"
                            data-teamname="Card 6 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 6 or further",
                                "1",
                                runner6l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner6l1">
                              {runner6l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6l1_matched"
                            >
                              {runner6l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr6_status span1details"
                            id="runner6l2span"
                            data-teamname="Card 6 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 6 or further",
                                "2",
                                runner6l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner6l2">
                              {runner6l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6l2_matched"
                            >
                              {runner6l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr6_status span1details"
                            id="runner6l3span"
                            data-teamname="Card 6 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 6 or further",
                                "3",
                                runner6l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner6l3">
                              {runner6l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner6l3_matched"
                            >
                              {runner6l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr6_status"
                            style={{
                              display:
                                suspend6 != 0 ||
                                rnr6_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr6_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b7status">
                          <h3
                            className={`runner-name ${
                              rnr7_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 7 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus7">
                                    {books.bookB7 !== "" ? (
                                      <span>
                                        {Number(books.bookB7) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB7)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB7)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL7)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr7_status span1details"
                            id="runner7b3span"
                            data-teamname="Card 7 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 7 or further",
                                "3",
                                runner7b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner7b3">
                              {runner7b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7b3_matched"
                            >
                              {runner7b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr7_status span1details"
                            id="runner7b2span"
                            data-teamname="Card 7 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 7 or further",
                                "2",
                                runner7b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner7b2">
                              {runner7b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7b2_matched"
                            >
                              {runner7b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr7_status span1details"
                            id="runner7b1span"
                            data-teamname="Card 7 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 7 or further",
                                "1",
                                runner7b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner7b1">
                              {runner7b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7b1_matched"
                            >
                              {runner7b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr7_status span1details"
                            id="runner7l1span"
                            data-teamname="Card 7 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 7 or further",
                                "1",
                                runner7l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner7l1">
                              {runner7l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7l1_matched"
                            >
                              {runner7l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr7_status span1details"
                            id="runner7l2span"
                            data-teamname="Card 7 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 7 or further",
                                "2",
                                runner7l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner7l2">
                              {runner7l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7l2_matched"
                            >
                              {runner7l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr7_status span1details"
                            id="runner7l3span"
                            data-teamname="Card 7 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 7 or further",
                                "3",
                                runner7l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner7l3">
                              {runner7l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner7l3_matched"
                            >
                              {runner7l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr7_status"
                            style={{
                              display:
                                suspend7 != 0 ||
                                rnr7_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr7_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b8status">
                          <h3
                            className={`runner-name ${
                              rnr8_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 8 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus8">
                                    {books.bookB8 !== "" ? (
                                      <span>
                                        {Number(books.bookB8) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB8)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB8)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL8)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr8_status span1details"
                            id="runner8b3span"
                            data-teamname="Card 8 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 8 or further",
                                "3",
                                runner8b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner8b3">
                              {runner8b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8b3_matched"
                            >
                              {runner8b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr8_status span1details"
                            id="runner8b2span"
                            data-teamname="Card 8 or furthere"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 8 or further",
                                "2",
                                runner8b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner8b2">
                              {runner8b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8b2_matched"
                            >
                              {runner8b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr8_status span1details"
                            id="runner8b1span"
                            data-teamname="Card 8 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 8 or further",
                                "1",
                                runner8b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner8b1">
                              {runner8b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8b1_matched"
                            >
                              {runner8b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr8_status span1details"
                            id="runner8l1span"
                            data-teamname="Card 8 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 8 or further",
                                "1",
                                runner8l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner8l1">
                              {runner8l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8l1_matched"
                            >
                              {runner8l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr8_status span1details"
                            id="runner8l2span"
                            data-teamname="Card 8 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 8 or further",
                                "2",
                                runner8l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner8l2">
                              {runner8l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8l2_matched"
                            >
                              {runner8l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr8_status span1details"
                            id="runner8l3span"
                            data-teamname="Card 8 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 8 or further",
                                "3",
                                runner8l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner8l3">
                              {runner8l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner8l3_matched"
                            >
                              {runner8l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr8_status"
                            style={{
                              display:
                                suspend8 != 0 ||
                                rnr8_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr8_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b9status">
                          <h3
                            className={`runner-name ${
                              rnr9_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 9 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus9">
                                    {books.bookB9 !== "" ? (
                                      <span>
                                        {Number(books.bookB9) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB9)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB9)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL9)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr9_status span1details"
                            id="runner9b3span"
                            data-teamname="Card 9 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 9 or further",
                                "3",
                                runner9b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner9b3">
                              {runner9b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9b3_matched"
                            >
                              {runner9b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr9_status span1details"
                            id="runner9b2span"
                            data-teamname="Card 9 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 9 or further",
                                "2",
                                runner9b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner9b2">
                              {runner9b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9b2_matched"
                            >
                              {runner9b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr9_status span1details"
                            id="runner9b1span"
                            data-teamname="Card 9 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 9 or further",
                                "1",
                                runner9b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner9b1">
                              {runner9b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9b1_matched"
                            >
                              {runner9b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr9_status span1details"
                            id="runner9l1span"
                            data-teamname="Card 9 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 9 or further",
                                "1",
                                runner9l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner9l1">
                              {runner9l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9l1_matched"
                            >
                              {runner9l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr9_status span1details"
                            id="runner9l2span"
                            data-teamname="Card 9 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 9 or further",
                                "2",
                                runner9l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner9l2">
                              {runner9l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9l2_matched"
                            >
                              {runner9l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr9_status span1details"
                            id="runner9l3span"
                            data-teamname="Card 9 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 9 or further",
                                "3",
                                runner9l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner9l3">
                              {runner9l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner9l3_matched"
                            >
                              {runner9l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr9_status"
                            style={{
                              display:
                                suspend9 != 0 ||
                                rnr9_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr9_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b10status">
                          <h3
                            className={`runner-name ${
                              rnr10_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 10 or further
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus10">
                                    {books.bookB10 !== "" ? (
                                      <span>
                                        {Number(books.bookB10) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB10)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB10)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL10)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr10_status span1details"
                            id="runner10b3span"
                            data-teamname="Card 10 or further"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 10 or further",
                                "3",
                                runner10b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner10b3">
                              {runner10b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner10b3_matched"
                            >
                              {runner10b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr10_status span1details"
                            id="runner10b2span"
                            data-teamname="Card 10 or further"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 10 or further",
                                "2",
                                runner10b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner10b2">
                              {runner10b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner10b2_matched"
                            >
                              {runner10b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr10_status span1details"
                            id="runner10b1span"
                            data-teamname="Card 10 or further"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 10 or further",
                                "1",
                                runner10b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner10b1">
                              {runner10b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner10b1_matched"
                            >
                              {runner10b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr10_status span1details"
                            id="runner10l1span"
                            data-teamname="Card 10 or further"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 10 or further",
                                "1",
                                runner10l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner10l1">
                              {runner10l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner10l1_matched"
                            >
                              {runner10l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr10_status span1details"
                            id="runner10l2span"
                            data-teamname="Card 10 or further"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 10 or further",
                                "2",
                                runner10l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner10l2">
                              {runner10l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner10l2_matched"
                            >
                              {runner10l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr10_status span1details"
                            id="runner10l3span"
                            data-teamname="Card 10 or further"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 10 or further",
                                "3",
                                runner10l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner10l3">
                              {runner10l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner10l3_matched"
                            >
                              {runner10l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr10_status"
                            style={{
                              display:
                                suspend10 != 0 ||
                                rnr10_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr10_status}
                          </div>
                        </div>
                      </div>
                      <div className="market-runners">
                        <div className="runner-runner" id="b11status">
                          <h3
                            className={`runner-name ${
                              rnr11_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  Card 11
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus11">
                                    {books.bookB11 !== "" ? (
                                      <span>
                                        {Number(books.bookB11) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB11)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB11)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL11)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr11_status span1details"
                            id="runner11b3span"
                            data-teamname="Card 11"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 11",
                                "3",
                                runner11b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner11b3">
                              {runner11b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner11b3_matched"
                            >
                              {runner11b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr11_status span1details"
                            id="runner11b2span"
                            data-teamname="Card 11e"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 11",
                                "2",
                                runner11b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner11b2">
                              {runner11b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner11b2_matched"
                            >
                              {runner11b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr11_status span1details"
                            id="runner11b1span"
                            data-teamname="Card 11"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "Card 11",
                                "1",
                                runner11b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner11b1">
                              {runner11b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner11b1_matched"
                            >
                              {runner11b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr11_status span1details"
                            id="runner11l1span"
                            data-teamname="Card 11"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 11",
                                "1",
                                runner11l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner11l1">
                              {runner11l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner11l1_matched"
                            >
                              {runner11l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr11_status span1details"
                            id="runner11l2span"
                            data-teamname="Card 11"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 11",
                                "2",
                                runner11l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner11l2">
                              {runner11l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner11l2_matched"
                            >
                              {runner11l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr11_status span1details"
                            id="runner11l3span"
                            data-teamname="Card 11"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "Card 11",
                                "3",
                                runner11l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner11l3">
                              {runner11l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner11l3_matched"
                            >
                              {runner11l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr11_status"
                            style={{
                              display:
                                suspend11 != 0 ||
                                rnr11_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr11_status}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="section-blur">
                      <div class="market-titlebar">
                        <p class="market-name"></p>
                        <div class="market-overarround">
                          <span></span>
                          <strong>Back</strong>
                        </div>
                        <div class="market-overarround market-overarround-lay">
                          <strong>Lay</strong>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b12status">
                          <h3
                            className={`runner-name ${
                              rnr12_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  2 Card Run
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus12">
                                    {books.bookB12 !== "" ? (
                                      <span>
                                        {Number(books.bookB12) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB12)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB12)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {books.bookL12}
                                          {formatTruncate(books.bookL12)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr12_status span1details"
                            id="runner12b3span"
                            data-teamname="2 Card Run"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "2 Card Run",
                                "3",
                                runner12b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner12b3">
                              {runner12b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner12b3_matched"
                            >
                              {runner12b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr12_status span1details"
                            id="runner12b2span"
                            data-teamname="2 Card Run"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "2 Card Run",
                                "2",
                                runner12b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner12b2">
                              {runner12b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner12b2_matched"
                            >
                              {runner12b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr12_status span1details"
                            id="runner12b1span"
                            data-teamname="2 Card Run"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "2 Card Run",
                                "1",
                                runner12b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner12b1">
                              {runner12b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner12b1_matched"
                            >
                              {runner12b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr12_status span1details"
                            id="runner12l1span"
                            data-teamname="2 Card Run"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "2 Card Run",
                                "1",
                                runner12l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner12l1">
                              {runner12l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner12l1_matched"
                            >
                              {runner12l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr12_status span1details"
                            id="runner12l2span"
                            data-teamname="2 Card Run"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "2 Card Run",
                                "2",
                                runner12l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner12l2">
                              {runner12l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner12l2_matched"
                            >
                              {runner12l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr12_status span1details"
                            id="runner12l3span"
                            data-teamname="2 Card Run"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "2 Card Run",
                                "3",
                                runner12l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner12l3">
                              {runner12l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner12l3_matched"
                            >
                              {runner12l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr12_status"
                            style={{
                              display:
                                suspend12 != 0 ||
                                rnr12_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr12_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b13status">
                          <h3
                            className={`runner-name ${
                              rnr13_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  3 Card Run
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus13">
                                    {books.bookB13 !== "" ? (
                                      <span>
                                        {Number(books.bookB13) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB13)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB13)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL13)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr13_status span1details"
                            id="runner13b3span"
                            data-teamname="3 Card Run"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "3 Card Run",
                                "3",
                                runner13b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner13b3">
                              {runner13b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner13b3_matched"
                            >
                              {runner13b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr13_status span1details"
                            id="runner13b2span"
                            data-teamname="3 Card Run"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "3 Card Run",
                                "2",
                                runner13b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner13b2">
                              {runner13b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner13b2_matched"
                            >
                              {runner13b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr13_status span1details"
                            id="runner13b1span"
                            data-teamname="3 Card Run"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "3 Card Run",
                                "1",
                                runner13b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner13b1">
                              {runner13b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner13b1_matched"
                            >
                              {runner13b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr13_status span1details"
                            id="runner13l1span"
                            data-teamname="3 Card Run"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "3 Card Run",
                                "1",
                                runner13l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner13l1">
                              {runner13l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner13l1_matched"
                            >
                              {runner13l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr13_status span1details"
                            id="runner13l2span"
                            data-teamname="3 Card Run"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "3 Card Run",
                                "2",
                                runner13l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner13l2">
                              {runner13l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner13l2_matched"
                            >
                              {runner13l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr13_status span1details"
                            id="runner13l3span"
                            data-teamname="3 Card Run"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "3 Card Run",
                                "3",
                                runner13l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner13l3">
                              {runner13l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner13l3_matched"
                            >
                              {runner13l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr13_status"
                            style={{
                              display:
                                suspend13 != 0 ||
                                rnr13_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr13_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b14status">
                          <h3
                            className={`runner-name ${
                              rnr14_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  4 Card Run
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus14">
                                    {books.bookB14 !== "" ? (
                                      <span>
                                        {Number(books.bookB14) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB14)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB14)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL14)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr14_status span1details"
                            id="runner14b3span"
                            data-teamname="4 Card Run"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "4 Card Run",
                                "3",
                                runner14b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner14b3">
                              {runner14b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner14b3_matched"
                            >
                              {runner14b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr14_status span1details"
                            id="runner14b2span"
                            data-teamname="4 Card Run"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "4 Card Run",
                                "2",
                                runner14b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner14b2">
                              {runner14b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner14b2_matched"
                            >
                              {runner14b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr14_status span1details"
                            id="runner14b1span"
                            data-teamname="4 Card Run"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "4 Card Run",
                                "1",
                                runner14b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner14b1">
                              {runner14b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner14b1_matched"
                            >
                              {runner14b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr14_status span1details"
                            id="runner14l1span"
                            data-teamname="4 Card Run"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "4 Card Run",
                                "1",
                                runner14l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner14l1">
                              {runner14l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner14l1_matched"
                            >
                              {runner14l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr14_status span1details"
                            id="runner14l2span"
                            data-teamname="4 Card Run"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "4 Card Run",
                                "2",
                                runner14l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner14l2">
                              {runner14l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner14l2_matched"
                            >
                              {runner14l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr14_status span1details"
                            id="runner14l3span"
                            data-teamname="4 Card Run"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "4 Card Run",
                                "3",
                                runner14l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner14l3">
                              {runner14l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner14l3_matched"
                            >
                              {runner14l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr14_status"
                            style={{
                              display:
                                suspend14 != 0 ||
                                rnr14_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr14_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b15status">
                          <h3
                            className={`runner-name ${
                              rnr15_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  No Ace
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus15">
                                    {books.bookB15 !== "" ? (
                                      <span>
                                        {Number(books.bookB15) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB15)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB15)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL15)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr15_status span1details"
                            id="runner15b3span"
                            data-teamname="No Ace"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("b", "No Ace", "3", runner15b3)
                            }
                          >
                            <span className="price-odd" id="runner15b3">
                              {runner15b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner15b3_matched"
                            >
                              {runner15b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr15_status span1details"
                            id="runner15b2span"
                            data-teamname="No Ace"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("b", "No Ace", "2", runner15b2)
                            }
                          >
                            <span className="price-odd" id="runner15b2">
                              {runner15b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner15b2_matched"
                            >
                              {runner15b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr15_status span1details"
                            id="runner15b1span"
                            data-teamname="No Ace"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("b", "No Ace", "1", runner15b1)
                            }
                          >
                            <span className="price-odd" id="runner15b1">
                              {runner15b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner15b1_matched"
                            >
                              {runner15b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr15_status span1details"
                            id="runner15l1span"
                            data-teamname="No Ace"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip("l", "No Ace", "1", runner15l1)
                            }
                          >
                            <span className="price-odd" id="runner15l1">
                              {runner15l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner15l1_matched"
                            >
                              {runner15l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr15_status span1details"
                            id="runner15l2span"
                            data-teamname="No Ace"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip("l", "No Ace", "2", runner15l2)
                            }
                          >
                            <span className="price-odd" id="runner15l2">
                              {runner15l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner15l2_matched"
                            >
                              {runner15l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr15_status span1details"
                            id="runner15l3span"
                            data-teamname="No Ace"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip("l", "No Ace", "3", runner15l3)
                            }
                          >
                            <span className="price-odd" id="runner15l3">
                              {runner15l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner15l3_matched"
                            >
                              {runner15l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr15_status"
                            style={{
                              display:
                                suspend15 != 0 ||
                                rnr15_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr15_status}
                          </div>
                        </div>
                      </div>

                      <div className="market-runners">
                        <div className="runner-runner" id="b16status">
                          <h3
                            className={`runner-name ${
                              rnr16_status == "WINNER" ? "sussesBg" : ""
                            }`}
                          >
                            <div className="runner-info">
                              <span className="clippable runner-display-name">
                                <h4
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  data-html="true"
                                  className="clippable-spacer"
                                >
                                  No Picture Cards
                                </h4>
                              </span>
                            </div>
                            <div className="runner-position">
                              <span>
                                <span className="">
                                  <strong id="bstatus16">
                                    {books.bookB16 !== "" ? (
                                      <span>
                                        {Number(books.bookB16) > 0 ? (
                                          <font color="green">
                                            {formatTruncate(books.bookB16)}
                                          </font>
                                        ) : (
                                          <font color="red">
                                            {formatTruncate(books.bookB16)}
                                          </font>
                                        )}
                                        <font style={{ color: "red" }}>
                                          {" "}
                                          /{" "}
                                        </font>
                                        <font style={{ color: "red" }}>
                                          {formatTruncate(books.bookL16)}
                                        </font>
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </strong>
                                </span>
                              </span>
                            </div>
                          </h3>

                          <a
                            className="price-price price-back rnr16_status span1details"
                            id="runner16b3span"
                            data-teamname="No Picture Cards"
                            data-bettype="b"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "No Picture Cards",
                                "3",
                                runner16b3
                              )
                            }
                          >
                            <span className="price-odd" id="runner16b3">
                              {runner16b3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner16b3_matched"
                            >
                              {runner16b3_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back rnr16_status span1details"
                            id="runner16b2span"
                            data-teamname="No Picture Cards"
                            data-bettype="b"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "No Picture Cards",
                                "2",
                                runner16b2
                              )
                            }
                          >
                            <span className="price-odd" id="runner16b2">
                              {runner16b2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner16b2_matched"
                            >
                              {runner16b2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-back mb-show rnr16_status span1details"
                            id="runner16b1span"
                            data-teamname="No Picture Cards"
                            data-bettype="b"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "b",
                                "No Picture Cards",
                                "1",
                                runner16b1
                              )
                            }
                          >
                            <span className="price-odd" id="runner16b1">
                              {runner16b1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner16b1_matched"
                            >
                              {runner16b1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay mb-show rnr16_status span1details"
                            id="runner16l1span"
                            data-teamname="No Picture Cards"
                            data-bettype="l"
                            data-selectRnr="1"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "No Picture Cards",
                                "1",
                                runner16l1
                              )
                            }
                          >
                            <span className="price-odd" id="runner16l1">
                              {runner16l1}
                            </span>
                            <span
                              className="price-amount"
                              id="runner16l1_matched"
                            >
                              {runner16l1_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr16_status span1details"
                            id="runner16l2span"
                            data-teamname="No Picture Cards"
                            data-bettype="l"
                            data-selectRnr="2"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "No Picture Cards",
                                "2",
                                runner16l2
                              )
                            }
                          >
                            <span className="price-odd" id="runner16l2">
                              {runner16l2}
                            </span>
                            <span
                              className="price-amount"
                              id="runner16l2_matched"
                            >
                              {runner16l2_matched}
                            </span>
                          </a>
                          <a
                            className="price-price price-lay rnr16_status span1details"
                            id="runner16l3span"
                            data-teamname="No Picture Cards"
                            data-bettype="l"
                            data-selectRnr="3"
                            onClick={() =>
                              showBetfairBetSlip(
                                "l",
                                "No Picture Cards",
                                "3",
                                runner16l3
                              )
                            }
                          >
                            <span className="price-odd" id="runner16l3">
                              {runner16l3}
                            </span>
                            <span
                              className="price-amount"
                              id="runner16l3_matched"
                            >
                              {runner16l3_matched}
                            </span>
                          </a>
                          <div
                            className="runner-disabled suspendCls  suspended-overlap"
                            id="rnr16_status"
                            style={{
                              display:
                                suspend16 != 0 ||
                                rnr16_status != "IN_PLAY" ||
                                evt_status == "SUSPENDED_GAME_ROUND_OVER"
                                  ? "block"
                                  : "none"
                            }}
                          >
                            {rnr16_status}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="ResultsData"
                  className="tabcontent"
                  style={{ display: showResult ? "contents" : "none" }}
                >
                  {resultData &&
                    resultData.length > 0 &&
                    resultData.map((dataObj, index) => {
                      let win1 = dataObj.rnr1_status;
                      let win2 = dataObj.rnr2_status;
                      let win3 = dataObj.rnr3_status;
                      let win4 = dataObj.rnr4_status;

                      let bgCls1 = win1 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls2 = win2 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls3 = win3 == "WINNER" ? "bgwinner" : "bgLoser";
                      let bgCls4 = win4 == "WINNER" ? "bgwinner" : "bgLoser";

                      let tdCls1 = win1 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls2 = win2 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls3 = win3 == "WINNER" ? "TdResultsWin" : "";
                      let tdCls4 = win4 == "WINNER" ? "TdResultsWin" : "";

                      let cardsArr = dataObj.cards_desc.split(",");
                      console.log("FULL DATA OBJECT:", dataObj);
                      console.log("cards_desc:", dataObj.cards_desc);
                      console.log("cardsArr:", cardsArr);
                      let rnr1Arr = [];
                      let resultArr = [];
                      for (let i = 1; i <= 16; i++) {
                        const key = dataObj[`cat_rnr${i}`];
                        const value = dataObj[`rnr${i}_status`];

                        if (key) {
                          resultArr[key] = value;
                        }
                      }
                      return (
                        <div class="left-content">
                          <div
                            class="card"
                            style={{
                              border: "1px solid rgb(204, 204, 204)",
                              borderRadius: "8px",
                              boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                              marginBottom: "5px",
                              background:
                                "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                              color: "white"
                            }}
                          >
                            <div
                              class="card-header no-border"
                              style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "5px",
                                backgroundColor: "rgba(0, 0, 0, .03)",
                                marginTop: "12px",
                                marginLeft: "16px"
                              }}
                            >
                              {formatResultDate(dataObj.evt_od)} - <b>ID=</b>{" "}
                              {dataObj._id}
                            </div>
                            <div class="card-body">
                              <div
                                class="players-table"
                                style={{ textAlign: "center", width: "100%" }}
                              >
                                <table style={tableStyle}>
                                  <tbody>
                                    <tr
                                      style={
                                        isMobile
                                          ? MobrowFlexStyle
                                          : rowFlexStyle
                                      }
                                    >
                                      <td
                                        style={{
                                          ...tdResultsStyle,
                                          height: "auto",
                                          minHeight: "115px"
                                        }}
                                        className="TdResults"
                                      >
                                        <div
                                          className="player-cards"
                                          style={playerCardsStyle}
                                        >
                                          <div
                                            className="player-name"
                                            style={playerNameStyle}
                                          >
                                            Community Cards
                                          </div>
                                          <div
                                            className="card-images"
                                            style={cardImagesStyle}
                                          >
                                            {cardsArr &&
                                              cardsArr.length > 0 &&
                                              cardsArr.map((card, index) => {
                                                const cardImage =
                                                  getCardImage(card);
                                                return (
                                                  <img
                                                    src={cardImage}
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                );
                                              })}
                                          </div>
                                        </div>
                                      </td>
                                    </tr>

                                    <tr style={rowFlexStyle}>
                                      {Object.entries(resultArr).map(
                                        ([category, status], index) =>
                                          status === "WINNER" && (
                                            <td
                                              key={index} // Key dena zaroori hai
                                              style={
                                                isMobile
                                                  ? MobtdResultsStyle
                                                  : tdResultsStyle
                                              }
                                              className={`TdResults TdResultsWin`}
                                            >
                                              <div
                                                className="player-cards"
                                                style={playerCardsStyle}
                                              >
                                                <div
                                                  className="player-name"
                                                  style={playerNameStyle}
                                                >
                                                  {category}
                                                </div>
                                                <div
                                                  className=""
                                                  style={
                                                    isMobile
                                                      ? MobplayerStatusStyle
                                                      : playerStatusStyle
                                                  }
                                                >
                                                  <img
                                                    src={getCardImage(
                                                      "NOT AVAILABLE"
                                                    )}
                                                    alt="Community Card"
                                                    loading="lazy"
                                                    style={cardImgStyle}
                                                  />
                                                </div>

                                                <div
                                                  className={`player-status bgwinner`}
                                                  style={
                                                    isMobile
                                                      ? MobplayerStatusStyle
                                                      : playerStatusStyle
                                                  }
                                                >
                                                  {status}{" "}
                                                  {/* Yahan status print hoga */}
                                                </div>
                                              </div>
                                            </td>
                                          )
                                      )}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div
                className="col-lg-4"
                style={{ paddingLeft: "1px", paddingRight: "1px" }}
              >
                <div className="right-content">
                  <div>
                    {showBetSlipPopup && (
                      <TPPopUpBetSlip
                        closeBetSlipParent={closeBetSlipMobile}
                        betObj={placeBetObject}
                        placeBetParent={placeBet}
                        loading={loading}
                        betButtonShow={betButtonShow}
                        betErrorMessageObj={betErrorMessageObj}
                        betButtonShowLoaderShow={betButtonShowLoaderShow}
                        profileData={profileData}
                        stakeList={stakeList}
                      />
                    )}
                    <BetfairCasinoBetslipWeb
                      showBetSlip={showBetSlip}
                      placeBetObject={placeBetObject}
                      closeBetSlipParent={closeBetSlip}
                      placeBetParent={placeBet}
                      loading={loading}
                      betErrorMessageObj={betErrorMessageObj}
                      stakeList={stakeList}
                    ></BetfairCasinoBetslipWeb>
                    <div className="bets">
                      <strong style={{ color: "white" }}>
                        Matched Bets ({totalBets})
                      </strong>
                      <div className="betting-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Runner</th>
                              <th>Price</th>
                              <th>Size</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody id="refreshhistory">
                            {betList.length > 0 ? (
                              betList.map((item, index) => (
                                <tr
                                  style={{
                                    background:
                                      item.type == "b" ? "#e9f6fc" : "#fce3e4",
                                    color: "#000",
                                    fontSize: "15px",
                                    textAlign: "center"
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "15px",
                                      display: "table-cell",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rnr !== "" ? (
                                      item.rnr == "runner1b1" ||
                                      item.rnr == "runner1b2" ||
                                      item.rnr == "runner1b3" ||
                                      item.rnr == "runner1l1" ||
                                      item.rnr == "runner1l2" ||
                                      item.rnr == "runner1l3" ? (
                                        <span>Card 1 or further</span>
                                      ) : item.rnr == "runner2b1" ||
                                        item.rnr == "runner2b2" ||
                                        item.rnr == "runner2b3" ||
                                        item.rnr == "runner2l1" ||
                                        item.rnr == "runner2l2" ||
                                        item.rnr == "runner2l3" ? (
                                        <span>Card 2 or further</span>
                                      ) : item.rnr == "runner3b1" ||
                                        item.rnr == "runner3b2" ||
                                        item.rnr == "runner3b3" ||
                                        item.rnr == "runner3l1" ||
                                        item.rnr == "runner3l2" ||
                                        item.rnr == "runner3l3" ? (
                                        <span>Card 3 or further</span>
                                      ) : item.rnr == "runner4b1" ||
                                        item.rnr == "runner4b2" ||
                                        item.rnr == "runner4b3" ||
                                        item.rnr == "runner4l1" ||
                                        item.rnr == "runner4l2" ||
                                        item.rnr == "runner4l3" ? (
                                        <span>Card 4 or further</span>
                                      ) : item.rnr == "runner5b1" ||
                                        item.rnr == "runner5b2" ||
                                        item.rnr == "runner5b3" ||
                                        item.rnr == "runner5l1" ||
                                        item.rnr == "runner5l2" ||
                                        item.rnr == "runner5l3" ? (
                                        <span>Card 5 or further</span>
                                      ) : item.rnr == "runner6b1" ||
                                        item.rnr == "runner6b2" ||
                                        item.rnr == "runner6b3" ||
                                        item.rnr == "runner6l1" ||
                                        item.rnr == "runner6l2" ||
                                        item.rnr == "runner6l3" ? (
                                        <span>Card 6 or further</span>
                                      ) : item.rnr == "runner7b1" ||
                                        item.rnr == "runner7b2" ||
                                        item.rnr == "runner7b3" ||
                                        item.rnr == "runner7l1" ||
                                        item.rnr == "runner7l2" ||
                                        item.rnr == "runner7l3" ? (
                                        <span>Card 7 or further</span>
                                      ) : item.rnr == "runner8b1" ||
                                        item.rnr == "runner8b2" ||
                                        item.rnr == "runner8b3" ||
                                        item.rnr == "runner8l1" ||
                                        item.rnr == "runner8l2" ||
                                        item.rnr == "runner8l3" ? (
                                        <span>Card 8 or further</span>
                                      ) : item.rnr == "runner9b1" ||
                                        item.rnr == "runner9b2" ||
                                        item.rnr == "runner9b3" ||
                                        item.rnr == "runner9l1" ||
                                        item.rnr == "runner9l2" ||
                                        item.rnr == "runner9l3" ? (
                                        <span>Card 9 or further</span>
                                      ) : item.rnr == "runner10b1" ||
                                        item.rnr == "runner10b2" ||
                                        item.rnr == "runner10b3" ||
                                        item.rnr == "runner10l1" ||
                                        item.rnr == "runner10l2" ||
                                        item.rnr == "runner10l3" ? (
                                        <span>Card 10 or further</span>
                                      ) : item.rnr == "runner11b1" ||
                                        item.rnr == "runner11b2" ||
                                        item.rnr == "runner11b3" ||
                                        item.rnr == "runner11l1" ||
                                        item.rnr == "runner11l2" ||
                                        item.rnr == "runner11l3" ? (
                                        <span>Card 11</span>
                                      ) : item.rnr == "runner12b1" ||
                                        item.rnr == "runner12b2" ||
                                        item.rnr == "runner12b3" ||
                                        item.rnr == "runner12l1" ||
                                        item.rnr == "runner12l2" ||
                                        item.rnr == "runner12l3" ? (
                                        <span>2 Card Run</span>
                                      ) : item.rnr == "runner13b1" ||
                                        item.rnr == "runner13b2" ||
                                        item.rnr == "runner13b3" ||
                                        item.rnr == "runner13l1" ||
                                        item.rnr == "runner13l2" ||
                                        item.rnr == "runner13l3" ? (
                                        <span>3 Card Run</span>
                                      ) : item.rnr == "runner14b1" ||
                                        item.rnr == "runner14b2" ||
                                        item.rnr == "runner14b3" ||
                                        item.rnr == "runner14l1" ||
                                        item.rnr == "runner14l2" ||
                                        item.rnr == "runner14l3" ? (
                                        <span>4 Card Run</span>
                                      ) : item.rnr == "runner15b1" ||
                                        item.rnr == "runner15b2" ||
                                        item.rnr == "runner15b3" ||
                                        item.rnr == "runner15l1" ||
                                        item.rnr == "runner15l2" ||
                                        item.rnr == "runner15l3" ? (
                                        <span>No Ace</span>
                                      ) : item.rnr == "runner16b1" ||
                                        item.rnr == "runner16b2" ||
                                        item.rnr == "runner16b3" ||
                                        item.rnr == "runner16l1" ||
                                        item.rnr == "runner16l2" ||
                                        item.rnr == "runner16l3" ? (
                                        <span>No Picture Cards</span>
                                      ) : (
                                        <span></span> // For any other value
                                      )
                                    ) : (
                                      <span></span>
                                    )}
                                    - {item.cat_mid}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.rate}
                                  </td>
                                  <td
                                    style={{
                                      display: "table-cell",
                                      textAlign: "left",
                                      padding: "5px"
                                    }}
                                  >
                                    {item.amnt}
                                  </td>
                                  <td></td>
                                </tr>
                              ))
                            ) : (
                              <tr></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </ClientLayout>
  );
};

export default BetfairHilo;


